(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sn-cart-dispatch"] && !Shopify.designMode) return;
  try {
    (function () {
    var HOLIDAYS = ['2026-12-25', '2026-12-28', '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28'];
    var CUTOFF = 14 * 60; // 2pm UK time, in minutes
    var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    // current UK wall-clock date and time, whatever the shopper's own time zone
    function ukNow() {
      var parts = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
        .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      var hour = parseInt(parts.hour, 10) % 24;
      return { y: +parts.year, m: +parts.month, d: +parts.day, mins: hour * 60 + parseInt(parts.minute, 10) };
    }
    function key(dt) { return dt.toISOString().slice(0, 10); }
    function isWorking(dt) { var w = dt.getUTCDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(key(dt)) === -1; }
    function render(el) {
      var n = ukNow();
      var today = new Date(Date.UTC(n.y, n.m - 1, n.d));
      var text;
      if (isWorking(today) && n.mins < CUTOFF) {
        var left = CUTOFF - n.mins, h = Math.floor(left / 60), m = left % 60;
        text = 'Order within <strong>' + (h ? h + 'h ' : '') + m + 'm</strong> for <strong>same-day dispatch</strong>. Delivered 2 working days after dispatch.';
      } else {
        var next = new Date(today.getTime());
        do { next.setUTCDate(next.getUTCDate() + 1); } while (!isWorking(next));
        var tomorrow = new Date(today.getTime()); tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
        var day = key(next) === key(tomorrow) ? 'tomorrow' : DAYS[next.getUTCDay()];
        text = 'Order now for dispatch <strong>' + day + '</strong>. Delivered 2 working days after dispatch.';
      }
      var t = el.querySelector('[data-sn-cart-dispatch-text]');
      if (t) t.innerHTML = text;
    }
    function all() { document.querySelectorAll('[data-sn-cart-dispatch]').forEach(render); }
    if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
    setInterval(all, 30000);
    // the theme re-renders the basket section after edits
    new MutationObserver(function () { var el = document.querySelector('[data-sn-cart-dispatch] [data-sn-cart-dispatch-text]'); if (el && !el.querySelector('strong')) all(); })
      .observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sn-colour-tiles"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__snColourTiles) return;
    window.__snColourTiles = true;
    function sync(box) {
      var select = document.getElementById(box.getAttribute('data-select'));
      if (!select) return;
      box.querySelectorAll('.sn-colour-tiles__tile').forEach(function (t) {
        var on = t.getAttribute('data-value') === select.value;
        t.setAttribute('aria-checked', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
    }
    function choose(box, tile) {
      var select = document.getElementById(box.getAttribute('data-select'));
      if (!select) return;
      var value = tile.getAttribute('data-value');
      if (select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync(box);
    }
    document.addEventListener('click', function (e) {
      var tile = e.target && e.target.closest && e.target.closest('.sn-colour-tiles__tile');
      if (!tile) return;
      choose(tile.closest('[data-sn-colour-tiles]'), tile);
    });
    // radio-group keyboard pattern: arrows move and select
    document.addEventListener('keydown', function (e) {
      var tile = e.target && e.target.closest && e.target.closest('.sn-colour-tiles__tile');
      if (!tile) return;
      var step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (!step) return;
      e.preventDefault();
      var box = tile.closest('[data-sn-colour-tiles]');
      var tiles = [].slice.call(box.querySelectorAll('.sn-colour-tiles__tile'));
      var next = tiles[(tiles.indexOf(tile) + step + tiles.length) % tiles.length];
      choose(box, next);
      next.focus();
    });
    var cache = {};
    function fmt(p) { return '£' + (p / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    function sized(src) { if (!src) return ''; if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=180'; }
    // keep each tile's image, price and availability in step with the other options the shopper has chosen
    function refresh(box) {
      var select = document.getElementById(box.getAttribute('data-select'));
      var form = select && select.closest('form');
      var url = box.getAttribute('data-url');
      var pos = parseInt(box.getAttribute('data-pos'), 10);
      if (!form || !url || !pos) return;
      var others = {};
      form.querySelectorAll('.product-form__single-selector').forEach(function (s) {
        var p = parseInt(s.getAttribute('data-option-position'), 10);
        if (p === pos || !p) return;
        if (s.tagName === 'SELECT' || s.checked) others[p] = s.value;
      });
      if (!cache[url]) cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      cache[url].then(function (product) {
        box.querySelectorAll('.sn-colour-tiles__tile').forEach(function (t) {
          var val = t.getAttribute('data-value');
          var v = null;
          (product.variants || []).some(function (x) {
            if (x.options[pos - 1] !== val) return false;
            for (var p in others) { if (x.options[p - 1] !== others[p]) return false; }
            v = x; return true;
          });
          t.classList.toggle('is-unavailable', !v || !v.available);
          if (!v) return;
          var img = t.querySelector('img');
          if (img && v.featured_image && v.featured_image.src) img.src = sized(v.featured_image.src);
          var pr = t.querySelector('[data-sn-ct-price]');
          if (pr) pr.textContent = fmt(v.price);
        });
      }).catch(function () {});
    }
    function syncAll() { document.querySelectorAll('[data-sn-colour-tiles]').forEach(sync); }
    document.addEventListener('variant:changed', function () { setTimeout(function () { syncAll(); document.querySelectorAll('[data-sn-colour-tiles]').forEach(refresh); }, 0); });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.product-form__single-selector')) syncAll();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sn-goods-total"] && !Shopify.designMode) return;
  try {
    (function () {
    function fmt(p) { return (p / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    function qtyOf(box) {
      var form = box.closest('form');
      var input = form && form.querySelector('input[name="quantity"]');
      var raw = input ? String(input.value).trim() : '1';
      var n = /^[0-9]+$/.test(raw) ? parseInt(raw, 10) : 0;
      return n > 0 ? n : 0;
    }
    function paint(box) {
      var price = parseInt(box.getAttribute('data-price'), 10);
      var title = box.getAttribute('data-title') || '';
      var sym = box.getAttribute('data-sym') || '£';
      var line = box.querySelector('[data-sn-goods-line]');
      var sum = box.querySelector('[data-sn-goods-sum]');
      var n = qtyOf(box);
      if (isNaN(price) || !n) { box.hidden = true; return; }
      box.hidden = false;
      var opt = title && title !== 'Default Title' ? title.replace(/\s+\/\s+/g, ', ') + ' at ' : '';
      line.textContent = n + ' × ' + opt + sym + fmt(price) + ' each';
      sum.textContent = sym + fmt(price * n);
    }
    function all() { document.querySelectorAll('[data-sn-goods-total]').forEach(paint); }
    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      document.querySelectorAll('[data-sn-goods-total]').forEach(function (box) {
        if (v) { box.setAttribute('data-price', v.price); box.setAttribute('data-title', v.title); }
        else { box.removeAttribute('data-price'); }
        paint(box);
      });
    });
    document.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') all(); });
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity') setTimeout(all, 0); });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-action$="-picker-quantity"]')) setTimeout(all, 0);
    });
    if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sn-grp-availability"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    document.querySelectorAll('[data-sn-grp-availability]').forEach(function (status) {
      if (!event.target.contains || !event.target.contains(status)) { return; }
      if (!variant) {
        status.textContent = status.dataset.invalid;
        status.dataset.state = 'unavailable';
        return;
      }
      var variantIds;
      try { variantIds = JSON.parse(status.dataset.variantIds); }
      catch (error) { return; }
      if (!variantIds.some(function (id) { return String(id) === String(variant.id); })) { return; }
      status.textContent = variant.available ? status.dataset.available : status.dataset.unavailable;
      status.dataset.state = variant.available ? 'available' : 'unavailable';
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sn-insert-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    var cache = {};
    function lrvMap(box) {
      var out = {};
      (box.getAttribute('data-lrv') || '').split('|').forEach(function (p) {
        var i = p.lastIndexOf(':');
        if (i > 0) out[p.slice(0, i)] = p.slice(i + 1);
      });
      return out;
    }
    function load(box) {
      var url = box.getAttribute('data-url');
      if (!cache[url]) cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      return cache[url];
    }
    function sized(src) {
      if (!src) return '';
      if (src.indexOf('//') === 0) src = 'https:' + src;
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
    }
    function render(box) {
      var select = document.getElementById(box.getAttribute('data-select'));
      var form = select && select.closest('form');
      var grid = box.querySelector('[data-sn-insert-grid]');
      if (!select || !form || !grid) return;
      var pos = parseInt(select.getAttribute('data-option-position'), 10);
      var others = {};
      form.querySelectorAll('.product-form__single-selector').forEach(function (s) {
        var p = parseInt(s.getAttribute('data-option-position'), 10);
        if (p !== pos && s.tagName === 'SELECT') others[p] = s.value;
      });
      var lrv = lrvMap(box);
      load(box).then(function (product) {
        var current = select.value;
        var colours = [].slice.call(select.options).map(function (o) { return o.value; });
        colours.sort(function (a, b) {
          var la = lrv[a] != null ? parseFloat(lrv[a]) : Infinity;
          var lb = lrv[b] != null ? parseFloat(lrv[b]) : Infinity;
          return la - lb;
        });
        grid.innerHTML = '';
        colours.forEach(function (c) {
          var match = null;
          (product.variants || []).some(function (v) {
            if (v.options[pos - 1] !== c) return false;
            for (var p in others) { if (v.options[p - 1] !== others[p]) return false; }
            match = v; return true;
          });
          var tile = document.createElement('button');
          tile.type = 'button';
          tile.className = 'sn-insert-guide__tile';
          tile.setAttribute('role', 'listitem');
          tile.setAttribute('aria-pressed', c === current ? 'true' : 'false');
          var img = match && match.featured_image && match.featured_image.src;
          var label = lrv[c] != null ? 'LRV ' + lrv[c] : 'LRV not stated';
          tile.innerHTML = (img ? '<img loading="lazy" alt="" src="' + sized(img) + '">' : '') +
            '<strong></strong><span></span>';
          tile.querySelector('strong').textContent = c;
          tile.querySelector('span').textContent = label;
          tile.setAttribute('aria-label', c + ', ' + label);
          tile.addEventListener('click', function () {
            select.value = c;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            var t = box.querySelector('.sn-insert-guide__toggle');
            box.querySelector('.sn-insert-guide__panel').hidden = true;
            t.setAttribute('aria-expanded', 'false');
            select.focus();
          });
          grid.appendChild(tile);
        });
      });
    }
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('.sn-insert-guide__toggle');
      if (!t) return;
      var box = t.closest('[data-sn-insert-guide]');
      var panel = box.querySelector('.sn-insert-guide__panel');
      var open = panel.hidden;
      panel.hidden = !open;
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) render(box);
    });
    document.addEventListener('variant:changed', function () {
      document.querySelectorAll('[data-sn-insert-guide]').forEach(function (box) {
        if (!box.querySelector('.sn-insert-guide__panel').hidden) render(box);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sn-length-finder"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__snLengthFinder) return;
    window.__snLengthFinder = true;
    function mm(v) { var m = /^\s*(\d+(?:\.\d+)?)\s*mm\b/i.exec(v || ''); return m ? parseFloat(m[1]) : NaN; }
    function run(box) {
      var select = document.getElementById(box.getAttribute('data-select'));
      var input = box.querySelector('[data-sn-lf-input]');
      var msg = box.querySelector('[data-sn-lf-msg]');
      if (!select || !input || !msg) return;
      var width = parseFloat(input.value);
      if (!(width > 0)) {
        msg.setAttribute('data-state', 'warn');
        msg.textContent = 'Enter your tread width in millimetres, measured at its widest.';
        return;
      }
      var best = null, max = null;
      [].slice.call(select.options).forEach(function (o) {
        var len = mm(o.value);
        if (isNaN(len)) return;
        if (max === null || len > max.len) max = { len: len, value: o.value };
        if (len >= width && (best === null || len < best.len)) best = { len: len, value: o.value };
      });
      if (!best) {
        msg.setAttribute('data-state', 'warn');
        msg.textContent = (max ? 'Wider than our longest stock length (' + max.value + '). ' : '') + 'Send us the step dimensions and we will advise before you order.';
        return;
      }
      if (select.value !== best.value) {
        select.value = best.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      msg.setAttribute('data-state', 'ok');
      msg.textContent = best.len === width
        ? 'Selected ' + best.value + ', which matches your ' + width + 'mm tread. One nosing per tread.'
        : 'Selected ' + best.value + ', the next stock length up from your ' + width + 'mm tread; cut to fit on site. One nosing per tread.';
    }
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[data-sn-lf-btn]');
      if (b) run(b.closest('[data-sn-length-finder]'));
    });
    // Enter inside the product form would submit it (add to cart): run the finder instead.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var i = e.target && e.target.closest && e.target.closest('[data-sn-lf-input]');
      if (!i) return;
      e.preventDefault();
      run(i.closest('[data-sn-length-finder]'));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sn-option-chips"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__snOptionChips) return;
    window.__snOptionChips = true;
    function boxes() { return document.querySelectorAll('[data-sn-option-chips]'); }
    function selectOf(box) { return document.getElementById(box.getAttribute('data-select')); }
    function sync(box) {
      var select = selectOf(box);
      if (!select) return;
      box.querySelectorAll('.sn-option-chips__chip').forEach(function (c) {
        var on = c.getAttribute('data-value') === select.value;
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
      });
    }
    // on swipe rows, bring the chosen chip into view without moving the page
    function reveal(box) {
      var on = box.querySelector('.sn-option-chips__chip[aria-checked="true"]');
      var list = on && on.parentNode;
      if (!list || list.scrollWidth <= list.clientWidth) return;
      var left = on.offsetLeft - list.offsetLeft;
      if (left >= list.scrollLeft && left + on.offsetWidth <= list.scrollLeft + list.clientWidth - 24) return;
      list.scrollLeft = Math.max(0, left - 8);
    }
    function choose(box, chip) {
      var select = selectOf(box);
      if (!select) return;
      var value = chip.getAttribute('data-value');
      if (select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync(box);
    }
    function visibleChips(box) {
      return [].slice.call(box.querySelectorAll('.sn-option-chips__chip')).filter(function (c) { return !c.hidden; });
    }
    function filter(box, q) {
      q = (q || '').trim().toLowerCase();
      var any = false;
      box.querySelectorAll('[data-sn-oc-group]').forEach(function (g) {
        var shown = 0;
        g.querySelectorAll('.sn-option-chips__chip').forEach(function (c) {
          var hit = !q || c.getAttribute('data-value').toLowerCase().indexOf(q) > -1;
          c.hidden = !hit;
          if (hit) shown++;
        });
        g.hidden = shown === 0;
        if (shown) any = true;
      });
      var empty = box.querySelector('[data-sn-oc-empty]');
      if (empty) empty.hidden = any;
    }
    var cache = {};
    // dim choices that have no variant for the other options the shopper has chosen
    function refresh(box) {
      var select = selectOf(box);
      var form = select && select.closest('form');
      var url = box.getAttribute('data-url');
      var pos = parseInt(box.getAttribute('data-pos'), 10);
      if (!form || !url || !pos) return;
      var others = {};
      form.querySelectorAll('.product-form__single-selector').forEach(function (s) {
        var p = parseInt(s.getAttribute('data-option-position'), 10);
        if (p === pos || !p) return;
        if (s.tagName === 'SELECT' || s.checked) others[p] = s.value;
      });
      if (!cache[url]) cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      cache[url].then(function (product) {
        box.querySelectorAll('.sn-option-chips__chip').forEach(function (c) {
          var val = c.getAttribute('data-value');
          var ok = (product.variants || []).some(function (x) {
            if (x.options[pos - 1] !== val) return false;
            for (var p in others) { if (x.options[p - 1] !== others[p]) return false; }
            return x.available;
          });
          c.classList.toggle('is-unavailable', !ok);
        });
      }).catch(function () {});
    }
    function init() {
      var list = boxes();
      if (!list.length) return;
      document.documentElement.classList.add('sn-oc-ready');
      list.forEach(function (box) {
        // picture tiles win where both exist for the same option
        var opt = box.closest('.product-form__option');
        if (opt && opt.querySelector('[data-sn-colour-tiles]')) { box.remove(); return; }
        box.classList.add('is-ready'); sync(box); reveal(box); refresh(box);
      });
    }
    document.addEventListener('click', function (e) {
      var chip = e.target && e.target.closest && e.target.closest('.sn-option-chips__chip');
      if (!chip) return;
      choose(chip.closest('[data-sn-option-chips]'), chip);
    });
    // radio-group keyboard pattern over the chips currently shown
    document.addEventListener('keydown', function (e) {
      var chip = e.target && e.target.closest && e.target.closest('.sn-option-chips__chip');
      if (!chip) return;
      var step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (!step) return;
      e.preventDefault();
      var box = chip.closest('[data-sn-option-chips]');
      var chips = visibleChips(box);
      var next = chips[(chips.indexOf(chip) + step + chips.length) % chips.length];
      choose(box, next);
      next.focus();
    });
    document.addEventListener('input', function (e) {
      if (!e.target || !e.target.matches || !e.target.matches('[data-sn-oc-search]')) return;
      filter(e.target.closest('[data-sn-option-chips]'), e.target.value);
    });
    // Enter in the search box picks the only match instead of submitting the form
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target || !e.target.matches || !e.target.matches('[data-sn-oc-search]')) return;
      e.preventDefault();
      var box = e.target.closest('[data-sn-option-chips]');
      var chips = visibleChips(box);
      if (chips.length === 1) { choose(box, chips[0]); chips[0].focus(); }
    });
    document.addEventListener('variant:changed', function () {
      setTimeout(function () { boxes().forEach(function (b) { sync(b); reveal(b); refresh(b); }); }, 0);
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.product-form__single-selector')) boxes().forEach(sync);
    });
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sn-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
    var bar = document.querySelector('[data-sn-satc]');
    if (!bar) return;
    var SEL = '.product-block-list__item--info [data-action="add-to-cart"], .product-block-list__item--info .product-form__add-button';
    // The theme can redraw the form when options change, so always look the real button up again.
    function realBtn() { return document.querySelector(SEL); }
    if (!realBtn()) return;
    var btn = bar.querySelector('[data-sn-satc-btn]');
    var priceEl = bar.querySelector('[data-sn-satc-price]');
    var cut = bar.getAttribute('data-cut') === '1';
    var hasOpts = bar.getAttribute('data-opts') === '1';
    var mq = window.matchMedia('(max-width: 999px)');
    var mode = '';

    function fmt(p) { return '£' + (p / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    // top of the buying area: the product form (fit check, options, quantity, Add to cart)
    function formEl(real) { return (real && real.closest('form')) || document.querySelector('.product-block-list__item--info form'); }
    function sync() {
      var real = realBtn();
      mode = '';
      if (real && mq.matches) {
        var r = real.getBoundingClientRect();
        var f = formEl(real);
        var fTop = f ? f.getBoundingClientRect().top : r.top;
        if (r.bottom < 0) mode = 'after';                          // scrolled past the real button
        else if (fTop > window.innerHeight - 80) mode = 'before';  // form not reached yet
      }
      var show = mode !== '';
      bar.hidden = !show;
      bar.setAttribute('data-mode', mode);
      document.body.classList.toggle('sn-satc-on', show);
      if (mode === 'before') {
        btn.disabled = false;
        btn.textContent = cut ? 'Choose your length' : (hasOpts ? 'Choose options' : 'Go to Add to cart');
      } else if (mode === 'after') {
        if (cut) btn.textContent = 'Choose your length';
        else if (real) {
          btn.disabled = real.disabled || real.classList.contains('button--disabled');
          btn.textContent = real.textContent.trim() || btn.textContent;
        }
      }
    }
    var ticking = false;
    function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; sync(); }); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (mq.addEventListener) mq.addEventListener('change', sync);
    sync();

    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      if (priceEl) priceEl.textContent = v ? fmt(v.price) : '';
      setTimeout(sync, 50);
    });

    btn.addEventListener('click', function () {
      if (mode === 'before') {
        // never adds to cart: take the shopper to the product form and focus its first choice
        var f = formEl(realBtn());
        if (!f) return;
        f.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var first = f.querySelector('.sn-colour-tiles__tile[aria-checked="true"], .sn-option-chips__chip[aria-checked="true"], select, input[type="radio"]:checked, input[type="number"], .product-form__add-button, [data-action="add-to-cart"]');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 450);
        return;
      }
      if (cut) {
        var tool = document.querySelector('[data-custom-length]') || realBtn();
        tool.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var input = tool.querySelector && tool.querySelector('input');
        if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 400);
        return;
      }
      var real = realBtn();
      if (btn.disabled || !real) return;
      real.click();
      // if the form refuses (validation message near the form), bring the form into view
      setTimeout(function () {
        var err = document.querySelector('.product-block-list__item--info .alert--error:not([hidden]), .product-block-list__item--info [role="alert"]:not([hidden])');
        if (err && err.offsetParent) err.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 700);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sn-sticky-checkout"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__snStickyCheckout) return;
    window.__snStickyCheckout = true;
    var mq = window.matchMedia('(max-width: 999px)');
    function realBtn() { return document.querySelector('form [name="checkout"]'); }
    function sync() {
      var bar = document.querySelector('[data-sn-scta]');
      if (!bar) { document.body.classList.remove('sn-satc-on'); return; }
      var real = realBtn();
      var show = false;
      if (real && mq.matches) {
        var r = real.getBoundingClientRect();
        show = r.bottom < 0 || r.top > window.innerHeight;
      }
      bar.hidden = !show;
      // shares the product-page bar's body class: page end padding and Stan lifted above the bar
      document.body.classList.toggle('sn-satc-on', show);
      var btn = bar.querySelector('[data-sn-scta-btn]');
      var blocked = !!real && (real.disabled || real.hasAttribute('disabled'));
      // the cut-length guard disabled checkout: the bar button takes the shopper to its message instead
      btn.toggleAttribute('data-blocked', blocked);
      btn.textContent = blocked ? 'Check cut lengths' : (real ? real.textContent.trim() : btn.textContent);
    }
    var ticking = false;
    function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; sync(); }); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (mq.addEventListener) mq.addEventListener('change', sync);
    // the theme re-renders the basket section after edits; re-check when the DOM changes
    new MutationObserver(onScroll).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[data-sn-scta-btn]');
      if (!b) return;
      if (b.hasAttribute('data-blocked')) {
        var msg = document.querySelector('form [role="alert"]') || realBtn();
        if (msg) msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var real = realBtn();
      if (real && !real.disabled) real.click();
    });
    if (document.readyState !== 'loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
  })();
  } catch(e) { console.error(e); }
})();

})();
